export default function(d) {
  return d;
}



//////////////////
// WEBPACK FOOTER
// ./~/@swimlane/ngx-charts/~/d3-shape/src/identity.js
// module id = 741
// module chunks = 0